import React from "react"
import CssBaseline from "@material-ui/core/CssBaseline"
import { Container } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles(theme => ({
  root: {
    padding: "15px",
    minHeight: "calc(100vh - 144px)",
    [theme.breakpoints.down("xs")]: {
      minHeight: "calc(100vh - 138px)",
    },
  },
}))

const DefaultContainer = ({ children }) => {
  const classes = useStyles()
  return (
    <>
      <CssBaseline />
      <Container maxWidth={"md"} className={classes.root}>
        {children}
      </Container>
    </>
  )
}

export default DefaultContainer
